import React, { Component } from 'react';
import styled from 'styled-components';
class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  handleClick = (id) => {
    window.open('/#/admin/sales/' + id, '_blank');
  };

  render() {
    const { icon, label, widthIcon, id } = this.props;

    return (
      <DivStyled onClick={() => this.handleClick(id)}>
        <ImgStyled src={icon} width={widthIcon} />
        <SpanStyled htmlFor={label}>{label}</SpanStyled>
      </DivStyled>
    );
  }
}

const DivStyled = styled.div`
  flex: 1;
  padding-bottom: 3px;
  margin-top: 8px;
  border-radius: 1px;
  align-self: center;
  justify-content: center;
  flex-direction: row;
  cursor: pointer;
`;

const SpanStyled = styled.span`
  vertical-align: 'center';
  font-weight: 400;
  font-size: 0.9em;
  margin-top: 18px;
  color: #656565;
`;

const ImgStyled = styled.img`
  vertical-align: 'center';
  margin-left: 4px;
  margin-right: 4px;
`;
export default ListItem;



// WEBPACK FOOTER //
// ./src/components/ListItem/ListItem.jsx